import {Component, EventEmitter, inject, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {ADMIN_MENU} from "@app/manager/utils/admin-menu.model";
import {NavigationEnd, Router} from "@angular/router";
import {SharedModule} from "@app/shared/shared.module";
import {filter, Subject, takeUntil} from "rxjs";


@Component({
  selector: 'ms-admin-side-panel',
  standalone: true,
  imports: [
    SharedModule,
  ],
  templateUrl: './admin-side-panel.component.html',
  styleUrl: './admin-side-panel.component.scss'
})
export class AdminSidePanelComponent implements OnInit, OnDestroy {
  @Input() hasShowSidePanel = false;
  @Output() showSidePanel = new EventEmitter<boolean>();
  @Output() closeSidenav = new EventEmitter<void>();

  private readonly router = inject(Router);
  private destroy$ = new Subject<void>();

  menus = ADMIN_MENU;
  currentRoute = '';

  ngOnInit() {
    // Observer les changements de route
    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        takeUntil(this.destroy$)
      )
      .subscribe((event: any) => {
        this.currentRoute = event.urlAfterRedirects;
      });

    // Initialiser la route actuelle
    this.currentRoute = this.router.url;
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onSidePanelToggle() {
    this.showSidePanel.emit(false);
    this.closeSidenav.emit();
  }

  onNavigate() {
    // Fermer le sidenav sur mobile après navigation
    if (window.innerWidth < 1200) {
      this.closeSidenav.emit();
    }
  }

  isActive(link: string): boolean {
    return this.currentRoute.includes(link);
  }

  getCurrentMenuLabel(): string {
    const currentMenu = this.menus.find(menu => this.isActive(menu.link));
    return currentMenu ? currentMenu.label : 'Tableau de bord';
  }

}
